import { createClient } from "@supabase/supabase-js";


export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be defined in environment variables");
}


export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: "public",
  },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    redirectTo: typeof window !== 'undefined' ? `${window.location.origin}/email-change-success` : undefined
  }
});

// Add debugging for Supabase auth events
supabase.auth.onAuthStateChange((event, session) => {
  console.log('🔐 [Supabase Auth] Auth state changed:', {
    event,
    session: session ? {
      user: session.user?.email,
      expires_at: session.expires_at,
      access_token: session.access_token ? 'Present' : 'Missing'
    } : null
  });
});
